import React from "react";
import { InputAdornment } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const SearchContent = ({ placeholderText, onChange }) => {
  return (
    <div className="flex justify-end h-[40px]">
      <CustomDesignedSearch
        // className="text-[12px] w-[490px] h-[40px] bg-[#FFFFFF] box-border rounded-[5px]"
        sx={{ height: "40px" , justifyContent : "center", width : "100%"}}
        placeholder={placeholderText}
        autoComplete={"off"}
        onChange={onChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon className="text-[19px]" />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};


const CustomDesignedSearch = styled(TextField)({
  "&.MuiFormControl-root": {
    maxWidth: "323px",
    width: "500px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
boxShadow: "0px 3px 15px #00000005",
border: "1px solid #C6C6C6",
borderRadius: "5px",
opacity: 1,
    // height: "40px",
  },
  "& .MuiOutlinedInput-root": {
    fontSize: "12px",
    fieldset: {
      border: "none",
      borderWidth: "0",
      padding: "0",
    },
  },
  "& .MuiInputAdornment-root":{
    marginRight:"0px"
  }
});


export default SearchContent;
